//@flow
import React from 'react';
import Slider from 'react-slick';
import './styles.scss';
import { TabView } from 'components/atoms/tabView';

type Props = {
  data: Array<RestaurantCategory>,
};

export const CarouselMobile = (props: Props) => {
  const { data, selectedItem, selectedId } = props;
  const settings = {
    dots: false,
    infinite: false,
    // slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    verticalSwiping: false,
    swipeToSlide: true,
    speed: 1000,
    touchThreshold: 3000,
    draggable: true,
    centerMode: false,
    variableWidth: true,
  };

  const renderTextSlider = () => {
    return data.map((item, idx) => (
      <div
        key={idx}
        onClick={() => selectedItem(item.id)}
        className={'carousel-row'}
      >
        <span className={`${selectedId === item.id && 'active-tab'}`}>
          {item.name}
        </span>
      </div>
    ));
  };

  return (
    <div className={'text-carousel-section'}>
      <Slider {...settings}>{renderTextSlider()}</Slider>
    </div>
  );
};
